import { defaultRpqMasivoProductos, defaultFiltro } from "./state";

/**
 * Mutación para ubicaciones.
 *
 * @param {*} state contiene la información de las variables del formulario.
 * @param {*} datos contiene la información del proceso.
 */
export function setInfo(state, datos) {
    state.info.empresa = datos.empresa;
    state.info.producto = datos.producto;
}

/**
 * Mutación para cargar las bases y áreas de un producto.
 *
 * @param {*} state contiene la información de las variables del formulario.
 * @param {*} datos contiene la información del proceso.
 */
export function setUbicaciones(state, datos) {
    state.ubicaciones = datos
}

export function setUbicacionesContratistas(state, ubicacionesContratista) {
  state.ubicacionesContratista = ubicacionesContratista
}

export function seleccionados(state, id) {
    state.seleccionado.push(id)
    state.marcados.push(id)
}

export function setSeleccionados(state, ubica) {
    state.ubicacion = ubica
}

export function cargarEstados(state, estados) {

    state.estados = [];

    for (var i = 0; i < estados.length; i++) {
        state.estados.push({ value: estados[i].id, text: estados[i].lista });
    }

}

export function CargarExisteNoExiste(state, control_existe) {

    state.control_existe = [];

    for (var i = 0; i < control_existe.length; i++) {
        state.control_existe.push({ value: control_existe[i].id, text: control_existe[i].lista });
    }

}

// trae al estate un solo producto
export function setProduct(state, product) {
    state.selectedProduct = product[0];
}

export function setProducto(state, producto) {
    state.selectedProduct = producto.data;
}

export function guardaProducto(state) {
    state.accion = 'update';
}

export function setProductos(state, productos) {

    if (productos.data.length > 0) {
        productos.data.forEach(element => {
            if (element.sga === null) {
                element.vacio = true
            }
            if (element.u_n === null) {
                element.vacio = true
            }
            if (element.hmis_fisico === null) {
                // element.vacio = true
                element.hmisData = 'NO'
            }
            if (element.hmis_personal === null) {
                // element.vacio = true
                element.hmisData = 'NO'
            }
            if (element.hmis_salud === null) {
                //  element.vacio = true
                element.hmisData = 'NO'
            }
            if (element.nfpa === null) {
                element.vacio = true
            }
        });
        state.productos = productos;
    } else {
        state.productos = [];
    }

}

export function productError(state, error) {
    state.error = error;
}

export function setFiltro(state, buscar) {
    state.filtro = buscar
}
export function setListaEmpresa(state, empresas) {
    state.empresas = empresas
}
export function setListaBases(state, bases) {
    state.bases = bases
}
export function setListaAreas(state, areas) {
    state.areas = areas
}
export function setListaCampos(state, campos) {
    state.campos = campos
}

export function setFiltroBases(state, bases) {
    state.filtro.base = bases;
}
export function setFiltroAreas(state, areas) {
    state.filtro.area = areas;
}

export function setAccion(state, accion) {
    state.accion = accion;
}

export function limpiarProducto(state) {
    state.selectedProduct = {
        id: '',
        activo: 1,
        verificado: 0,
        nombre: '',
        sinonimos: '',
        componentesactivos: '',
        componentesactivosIngles: '',
        cas: '',
        estado: '',
        proveedorfabricante: '',
        uso: '',
        observacion: '',
        disposiciontratamiento: '',
        doc_sga: '',
        doc_etiqueta: '',
        fecha_etiqueta: '',
    }
}

export function setComponente(state, componente) {
    state.selectedProduct.componentesactivos = componente
}

export function setPage(state, page) {
    state.filtro.page = page
}
export function setPermisosAdmin(state, permiso) {
    state.esAdmin = permiso
}
export function setPermisosEmpresa(state, permiso) {
    state.esEmpresa = permiso
}


export function asignaEmpresa(state, id_empresa) {
    state.filtro.empresa = id_empresa;
}

/**
 * Mutación que carga la información de campos personalizados de la pantalla de empresas.
 *
 * @param {*} state contiene la información de las variables del formulario.
 * @param {*} campos contiene la información de campos personalizados.
 */
export function setCamposPersonalizados(state, campos) {
    state.camposPersonalizados = campos;
}

/**
 * Método que carga la infromación de Cas de la generales.
 *
 * @param {*} state contiene la información de las variables del formulario.
 * @param {*} data contiene la información de cas de la generales.
 */
export function setCasEmpresa(state, data) {
    state.tlvs = []
    state.iarcs = []
    state.ototoxicos = []
    state.neurotoxicos = []
    state.sustanciasControladas = []
    state.biopersistentes = []
    state.reprotoxicos = []
    state.mutagenicos = []
    state.teratogenicos = []

    state.tlvs = data.Cas.filter(i => i.tipo == 'Tlv')
    state.iarcs = data.Cas.filter(i => i.tipo == 'Iarc')
    state.sustanciasControladas = data.Cas.filter(i => i.tipo == 'Sustancias_controladas')
    state.neurotoxicos = data.Cas.filter(i => i.tipo == 'Neurotoxicos')
    state.ototoxicos = data.Cas.filter(i => i.tipo == 'Ototoxicos')
    state.biopersistentes = data.Cas.filter(i => i.tipo == 'Biopersistente')
    state.mutagenicos = data.Cas.filter(i => i.tipo == 'Mutagenicos')
    state.teratogenicos = data.Cas.filter(i => i.tipo == 'Teratogenicos')
    state.reprotoxicos = data.Cas.filter(i => i.tipo == 'Reprotoxicos')

    /* state.tlvs = []
    state.iarcs = []
    state.otos = []
    state.neuros = []
    state.scs = []
    state.bios = []
    state.repros = []
    state.mutas = []
    state.teras = []


    data.Cas.forEach(i => {

        if (i.tipo == "Tlv") { //TLV
            state.tlvs.push(
                i.datos.datos
            );
        }
        if (i.tipo == "Iarc") { //Iarc
            state.iarcs.push(
                i.datos.datos
            );

        }
        if (i.tipo == "Sustancias_controladas") { //SC
            state.scs.push(
                i.datos.datos
            );
        }
        if (i.tipo == "Neurotoxicos") { //Neurotoxicos
            state.neuros.push(
                i.datos.datos
            );
        }
        if (i.tipo == "Ototoxicos") { //Ototoxicos
            state.otos.push(
                i.datos.datos
            );
        }
        if (i.tipo == "Biopersistente") { //Biopersistente
            state.bios.push(
                i.datos.datos
            );
        }

        if (i.tipo == "Mutagenicos") { //Mutagenicos
            state.mutas.push(
                i.datos.datos
            );
        }
        if (i.tipo == "Teratogenicos") { //Teratogenicos
            state.teras.push(
                i.datos.datos
            );
        }
        if (i.tipo == "Reprotoxicos") { //Reprotoxicos
            state.repros.push(
                i.datos.datos
            );
        }

    }) */
}
/**
 * Mutación para asignar los productos al RPQ de manera masiva
 *
 * @export
 */
export function setRpqMasivoProductos(state, producto) {
  let tipo = producto.tipo;

  if (tipo == 'verificado') {
    let indice = state.rpqMasivoProductos.verificado.findIndex(i => i.id_producto === producto.id_producto);

    if (indice != -1) {
      state.rpqMasivoProductos.verificado.splice(indice, 1);
    }else {
      state.rpqMasivoProductos.verificado.push(producto);
    }
  } else if (tipo == 'asignado') {
    let indice = state.rpqMasivoProductos.asignado.findIndex(i => i.id_producto === producto.id_producto);
    if (indice != -1) {
      state.rpqMasivoProductos.asignado.splice(indice, 1);
    }else {
      state.rpqMasivoProductos.asignado.push(producto);
    }
  } else if (tipo == 'pago') {
    let indice = state.rpqMasivoProductos.pago.findIndex(i => i.id_producto === producto.id_producto);
    if (indice != -1) {
      state.rpqMasivoProductos.pago.splice(indice, 1);
    }else {
      state.rpqMasivoProductos.pago.push(producto);
    }
  } else if (tipo == 'te') {
    let indice = state.rpqMasivoProductos.te.findIndex(i => i.id_producto === producto.id_producto);
    if (indice != -1) {
      state.rpqMasivoProductos.te.splice(indice, 1);
    }else {
      state.rpqMasivoProductos.te.push(producto);
    }
  }
}

/**
 * Mutación para limpiar la asignación de productos en masivo
 *
 * @param {*} state
 */
export function limpiarRpqMasivoProductos(state) {
    Object.assign(state.rpqMasivoProductos, defaultRpqMasivoProductos());
}

/**
 * Mutación para limpiar las bases y areas de la vista generales.
 *
 * @param {*} state
 */
export function limpiaBasesAreasEmpresa(state) {
    state.list_basesareas = [];
}


/**
 * Mutación para limpiar las bases y areas de la vista generales.
 *
 * @param {*} state
 */
export function setCodigoQR(state, respuesta) {
    if (respuesta.codigo != '') {
        state.codigoqr.qr = respuesta.codigo;
        state.codigoqr.qr2 = respuesta.codigo2;
    } else {
        state.codigoqr.mensajeqr = respuesta.message;
    }
}

/**
 * Mutación para limpiar los filtros de búsqueda.
 *
 * @export
 * @param {*} state
 */
export function resetFiltro(state) {
    let filtro = defaultFiltro();
    filtro.empresa = state.filtro.empresa;
    Object.assign(state.filtro, filtro);
}

/**
 * Mutación para limpiar los productos de la tabla.
 *
 * @export
 * @param {*} state
 */
export function resetProducts(state) {
    state.productos = [];
}

export function setFiltroUbicacion(state, ubicaciones) {
  state.filtro.ubicaciones = ubicaciones
}

export function setFabricantes(state, fabricantes) {
  state.fabricantes = fabricantes
}

export function establecerCargandoDatosSelect(state, cargando_datos_select) {
  state.cargando_datos_select = cargando_datos_select;
}
